export { ModalCloseButton } from '@chakra-ui/react';

export * from './Modal';
export * from './types';
